import React from 'react';
import { Button } from 'seagull';
import { MobileSign } from "../clientOb/components/MobileSign";
import Signature from "../clientOb/components/Signature";
import { relationshipModel } from "../../models";
import styles from "./AcceptProposalButton.module.scss";
import { Intent } from "../../infra/access-control";
const ApproveProposalButton = _ref => {
  let {
    testid,
    disabled,
    isDesktop,
    relationship,
    previewStatus,
    onDone
  } = _ref;
  return previewStatus && previewStatus.inModal ? /*#__PURE__*/React.createElement(Button, {
    onClick: previewStatus.onDismissPreviewModal,
    fluid: true,
    "data-testid": "preview-dismiss-modal"
  }, "Close preview") : isDesktop ? /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, disabled || /*#__PURE__*/React.createElement(Signature, {
    className: styles.signature
  }, relationshipModel.buyerFullName(relationship)), /*#__PURE__*/React.createElement(Button, {
    onClick: onDone,
    fluid: true,
    intent: Intent.ApproveProposal,
    disabled: disabled,
    "data-testid": testid
  }, "Click to approve agreement")) : /*#__PURE__*/React.createElement(MobileSign, {
    intent: Intent.ApproveProposal,
    relationship: relationship,
    disabled: disabled,
    onSign: () => onDone()
  });
};
export default ApproveProposalButton;